import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, DollarSign, TrendingUp, BarChart3 } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function LevelupInsurance() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-349" data-mp="n7onk1dvvf71">
      <div className="max-w-6xl mx-auto px-4" data-id="element-350" data-mp="n9j4l4m1an5u">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-351" data-mp="3vnrshzdm2pro">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-352" data-mp="8jlcidkzhdbd" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-353" data-mp="3hw0ovpxsvm8">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-354" data-mp="1jxp4xfbxateb">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-355" data-mp="1jw4bjt1chgi1">
              Insurance
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-356" data-mp="y0npvj8ub0q6">
              Scaling
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-357" data-mp="172n4k4wdtspy">
              Paid Search
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-358" data-mp="edzhq4vzivaa">
            Levelup Insurance
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-359" data-mp="j9oi2aftwg7n">
            Scaling High-Quality Leads Nationwide
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-360" data-mp="3rruhb4nqs62t">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-361" data-mp="3rsmbqc5lrxri">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-362" data-mp="ljjrihxxng8">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-363" data-mp="3ooexh5scpa9j">
                <DollarSign className="w-24 h-24 text-engage-yellow" data-id="element-364" data-mp="3kmjsnrb7oer0" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-365" data-mp="29vl1emxs55p">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-366" data-mp="3thhq9bpb0foo">
                  <DollarSign className="w-6 h-6 text-engage-yellow" data-id="element-367" data-mp="31ps4p4kq5bgm" />
                </div>
                <div data-id="element-368" data-mp="31s4wsak7527e">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-369" data-mp="3fp9v1odo4ws3">
                    $70K
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-370" data-mp="3ap5gi3wbmc4i">
                    Monthly Ad Spend
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-371" data-mp="q2lqd50c3q70">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-372" data-mp="2cyikg0z9k8ze">
                <TrendingUp className="w-24 h-24 text-engage-yellow" data-id="element-373" data-mp="1yz0pf3vdjzhl" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-374" data-mp="23wsqoohwsxyg">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-375" data-mp="2rn4ylzd5mup1">
                  <TrendingUp className="w-6 h-6 text-engage-yellow" data-id="element-376" data-mp="2vp9p4p8b3b7g" />
                </div>
                <div data-id="element-377" data-mp="2htxwqohmhwtp">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-378" data-mp="2mv52ki07glxq">
                    -45%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-379" data-mp="3aj4u3k5ccgdd">
                    Cost Per Lead
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-380" data-mp="1qqwi4rjoknqe">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-381" data-mp="1hpyi0kcd50d3">
                <BarChart3 className="w-24 h-24 text-engage-yellow" data-id="element-382" data-mp="1crers7qql2ex" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-383" data-mp="29et69zctypab">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-384" data-mp="25e9aaz3ztrpr">
                  <BarChart3 className="w-6 h-6 text-engage-yellow" data-id="element-385" data-mp="20lybjzkzobys" />
                </div>
                <div data-id="element-386" data-mp="1vo6gwxsymbqw">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-387" data-mp="1vmvfv5qwfi3h">
                    10x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-388" data-mp="2occ3lq3kqatd">
                    Volume Growth
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-389" data-mp="35m6at4jxja0a">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-390" data-mp="35p28qsvs1yoq">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-391" data-mp="39ly9mpjiu1sg">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-392" data-mp="3jm77s8x2pxah" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-393" data-mp="3jk4cb9d5jbyd">
              Level Up had worked with multiple providers but struggled with
              inconsistent and low-quality leads that didn{'\u2019'}t convert.
              Scaling was limited by poor lead intent and lack of reliable
              systems, while bilingual communication added complexity. The
              challenge was to grow volume without sacrificing quality or
              conversion.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-394" data-mp="1yaorxzz7d5xt">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-395" data-mp="2c11vlq529yhc">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-396" data-mp="2790f1s0v1lli" />
              <div className="relative z-10" data-id="element-397" data-mp="2gzlns8a906i5">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-398" data-mp="2gytpgpp9nuo6">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-399" data-mp="2ux0gpmzpmwev" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-400" data-mp="2q12z7dcpnk0i">
                  We built a bilingual acquisition system focused on trust,
                  clarity, and performance. Through native messaging,
                  high-converting creatives, and a structured funnel, we
                  attracted higher-intent prospects while maintaining
                  scalability. Continuous optimization ensured both efficiency
                  and consistent improvement.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-401" data-mp="32idudza11w4q">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-402" data-mp="2oicrkea7cemm" />
              <div className="relative z-10" data-id="element-403" data-mp="2fifxty8ygpkp">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-404" data-mp="2fjrc4s011fq2">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-405" data-mp="2jm47qnl27x94" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-406" data-mp="drl216er0qdz">
                  Level Up scaled aggressively while improving lead quality and
                  maintaining performance. The business expanded nationwide,
                  generated consistent lead flow, and established a reliable
                  system capable of supporting long-term growth.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-407" data-mp="2mz1bslaomq5l">
            <div className="flex justify-center mb-8" data-id="element-408" data-mp="2dz4ksd0tlf7d">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-409" data-mp="2dybj3qgpxfw3">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-410" data-mp="796s4o0seg3r" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-411" data-mp="jl8uy8zba0pl">
              We finally found a system that delivers the right leads{'\u2014'}
              consistently and at scale.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-412" data-mp="rvibjzgugys">
              <img src="https://cdn.magicpatterns.com/uploads/2V6pxVhveoDPxpW8Zxr6BS/LevelUpInsurance-CS.png" alt="Level Up Insurance" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-413" data-mp="urh1aj519oa" />
              <div className="font-bold text-engage-white text-lg" data-id="element-414" data-mp="1h8hmolpwo601">
                Levelup Insurance Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-415" data-mp="2q2pbldvc9iex">
                CEO, Levelup Insurance
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-416" data-mp="2yu7sjr040292">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-417" data-mp="22735zsimewm0" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-418" data-mp="2b5onrlg9q7lq">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-419" data-mp="2b4dh9dvfulqx">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-420" data-mp="3ml3pt3nc3pnp">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-421" data-mp="5i7nbeo72na0">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}